export default {
  info1: 'En esta sección se puede configurar cómo se realiza el acceso de forma remota y desatendida mediante servicios web. Debe indicar qué tipo de acceso necesita y las credenciales del mismo. Consulte con su integrador para saber qué tipo de acceso debe configurar.',
  info2: 'Si utiliza el Conector Sistema eFactura, deberá configurar el acceso por llave.',
  title: 'Configuración del acceso mediante ERP',
  radioButtons: {
    unauthorized: 'No autorizado',
    byPassword: 'Por contraseña',
    byKey: 'Por llave'
  },
  help: 'Llave electrónica (fichero) que le permitirá acceder al servicio de forma remota. Esta llave estará cifrada con la contraseña y deberá ser utilizada junto con el fichero en la llamada para el acceso remoto.',
  accessType: 'Tipo de acceso',
  id: '51234567A',
  downloadKey: 'Descargar Llave',
  identifier: 'Identificador',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña'
}
